import { Button, DialogActions } from "@mui/material";
import type { PropsWithChildren, ReactNode } from "react";
import HorizontalFill from "./HorizontalFill";

interface Props {
  onCancel?: () => void;
  cancelText?: string;
  cancelDisabled?: boolean;
  startAction?: ReactNode;
}

const DialogButtons = ({ onCancel, cancelText, cancelDisabled, startAction, children }: PropsWithChildren<Props>) => {
  return (
    <DialogActions sx={{ py: 2, px: 3, columnGap: 1 }}>
      {startAction && (
        <>
          {startAction}
          <HorizontalFill />
        </>
      )}

      {onCancel && (
        <Button variant="text" color="secondary" autoFocus onClick={onCancel} disabled={cancelDisabled}>
          {cancelText || "Cancel"}
        </Button>
      )}

      {children}
    </DialogActions>
  );
};

export default DialogButtons;
